// extracted by mini-css-extract-plugin
export var alignLeft = "s_pL d_bF";
export var alignCenter = "s_bN d_bC";
export var alignRight = "s_pM d_bG";
export var hoursInnerWrapperAlt = "s_rm d_d9 d_N d_Y d_by d_bC d_bN d_dh";
export var hoursInnerWrapperLeft = "s_rn d_fb d_d9 d_N d_Y d_by d_bC d_bN d_b4 d_dh";
export var hoursText = "s_rp d_dv";
export var titleMargin = "s_rq d_cv";
export var hoursInnerInnerWrapper = "s_rr d_cy";